import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResumenExpedienteDto } from '../dto/expediente/resumen-expediente.dto';
import { Constants } from '../constants/constants';
import { ComunicadoDto } from '../dto/comunicado/comunicado.dto';

@Injectable({
  providedIn: 'root',
})
export class ResumenGeneralService {
  private readonly urlBase = environment.apiUrl;
  private readonly http = inject(HttpClient);

  obtenerResumenExpedientesPorUsuario(): Observable<ResumenExpedienteDto[]> {
    const url = `${this.urlBase}/expediente/resumen`;
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);    
    const headers =
    { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    }
    const response = this.http.get<ResumenExpedienteDto[]>(url , { headers });
    return response;
  }

  obtenerComunicadosUltimoMes(): Observable<ComunicadoDto[]> {
    const url = `${this.urlBase}/comunicado/ultimo-mes`;
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
    return this.http.get<ComunicadoDto[]>(url, { headers });
  }
}
